import React, { useEffect, useState, useMemo } from "react";
import { Table, Dropdown, Icon, Popup } from "semantic-ui-react";
import { Line } from "@ant-design/charts";
import { Pie, Column, DualAxes } from "@ant-design/plots";
import {
  Permission,
  // Form,
  // Productionform,
  // Socialform,
  // Waterform,
} from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./WaterKPIsDashBoard.scss";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { CollapsibleSection, LoadingSpinner } from "../../../Shared";
//import { Renderer as SVGRenderer } from '@antv/g-svg';
import WaterSummary from "./WaterSummary";
import TableGraf from "./TableGraf";
import {
  waterKPIsCodes,
  waterFormulasIndicators,
  determineWaterUnits,
  waterCodes,
  convertUnitsFinal,
} from "../../../../utils/dataAndFormulas/waterForms.js";

/*import {
  convertUnits,
 // convertUnitsFinal,
  formatValue,
} from "../../../../utils/dataAndFormulas/convert";*/
//import convert from "convert-units";
import {
  convertUnits,
} from "../../../../utils/dataAndFormulas/convert";

const permissionController = new Permission();
// const waterController = new Waterform();
// const formController = new Form();
// const productionController = new Productionform();
// const socialController = new Socialform();

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function WaterKPIsDashBoard(props) {
  const { site, sharedProductionForms } = props;
  const {
    user: { role },
    accessToken,
  } = useAuth();

  const { language, translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [permissionActive, setPermissionsActive] = useState([]);
  const [baseline, setbaseline] = useState("");
  const [valueBaseline, setValueBaseline] = useState({});
  const [indicatorsLineBase, setIndicatorsLineBase] = useState([]);
  const [loading, setLoading] = useState(true);
  // const isAdmin = (role? role.name : "") === "admin";

  const [data, setData] = useState([]);
  const [totales, setTotales] = useState({});
  const [conceptos, setConceptos] = useState([]);
  const [configFormData, setConfigFormData] = useState(null);

  const [workersTotals, setWorkersTotals] = useState([]);
  const [workersTotalsByPeriod, setWorkersTotalsByPeriod] = useState([]);

  const [loadingCount, setLoadingCount] = useState(0);
  const isLoading = loadingCount > 0;
  const [lastYears, setLastYears] = useState({}); // resultados calculados
  const [totalesByFilters, setTotalesByFilters] = useState({}); // resultados calculados
  const [totalesProductionsByFilters, setTotalesProductionsByFilters] =
    useState({}); // resultados calculados

  const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

  //declaración estado de filtros
  const [filters, setFilters] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true,
          );
          setPermissionsActive(response);
        }
      } catch (error) {
        waterKPIsCodes.error(error);
        setPermissionsActive([]);
      } finally {
        stopLoading();
      }
    })();
  }, []);

  useEffect(() => {
    if (!site) return;

    const fetchData = async () => {
      startLoading();
      setData([]);
      setbaseline("");
      try {
        // --- 1. Obtener años de línea base y últimos 5 años ---
        const prueba = await waterController.getWaterFormsByLineBaseYears(
          accessToken,
          site,
        );

        setIndicatorsLineBase(prueba.waterForms.indicators);
        const yearsLineaBase = prueba.waterForms.years;
        const currentYear = new Date().getFullYear();
        const yearsUltimos5 = Array.from({ length: 5 }, (_, i) =>
          String(currentYear - i),
        );
        const añosCombinados = [
          ...new Set([...yearsLineaBase, ...yearsUltimos5]),
        ];

        // --- 2. Obtener datos de waterForms ---
        const responseWater = await waterController.getWaterFormsByLastYears(
          accessToken,
          site,
          añosCombinados,
        );
        setData(responseWater.waterForms);

        // --- 3. Obtener totales de trabajadores por periodo ---
        const totalWorkersByYearAndPeriod =
          await socialController.getTotalWorkersByYearsAndPeriod(
            accessToken,
            site,
            añosCombinados,
          );
        const workersByPeriod =
          totalWorkersByYearAndPeriod.totalWorkersByPeriod;
        setWorkersTotalsByPeriod(workersByPeriod);

        // --- 3.2 Calcular promedio de trabajadores por año desde los datos por periodo ---
        const workersAvgByYear = {};
        Object.entries(workersByPeriod || {}).forEach(([year, monthsData]) => {
          const values = Object.values(monthsData || {});
          const validValues = values.filter((v) => v > 0);
          const avg =
            validValues.length > 0
              ? validValues.reduce((a, b) => a + b, 0) / validValues.length
              : 0;
          workersAvgByYear[year] = Math.round(avg);
        });
        setWorkersTotals(workersAvgByYear);

        // --- 4. Obtener baseline ---
        const responseBaseline =
          await formController.getLastBaselineByFormBySite(
            accessToken,
            site,
            "production",
          );

        if (responseBaseline.code === 200) {
          setbaseline(responseBaseline.baseline);

          //Para saber el total de los años de baseline sin necesidad de andar consultando varias veces
          const resultado = await Promise.all(
            Object.entries(responseBaseline.baseline)
              .filter(([anio, valor]) => valor !== null) // Filtra por los valores no nulos
              .map(async ([anio, valor]) => {
                let a = await getValueBaseLine(anio, valor); // Llamada a la función asincrónica
                return { [anio]: a }; // Devuelve el año y el valor como un objeto
              }),
          );

          // Combina todos los objetos en un único objeto final
          const resultadoFinal = resultado.reduce((acc, obj) => {
            return { ...acc, ...obj }; // Combina los objetos
          }, {});

          setValueBaseline(resultadoFinal);
          //setData(response.waterForms); // obtengo los formularios de los ultimos 5 años

          // Aquí puedes guardar los datos en estado, por ejemplo:
          //setWorkersTotals(totalWorkersByYear.totalWorkers);

          setLoading(false);
        }
      } catch (error) {
        //console.error(error);
        setData([]);
      } finally {
        stopLoading();
      }
      // } catch (error) {
      //   console.error(error);
      //   setData([]);
      // } finally {
      //   stopLoading();
      // }
    };

    fetchData();
  }, [site]);

  // Obtener configuración de campos activos del formulario
  useEffect(() => {
    (async () => {
      try {
        if (site) {
          const response = await formController.getFormsBySite(
            accessToken,
            site,
            "water",
            true,
          );
          // La respuesta es directamente un array de formularios
          if (Array.isArray(response) && response.length > 0) {
            setConfigFormData(response[0]);
          } else {
            setConfigFormData(null);
          }
        }
      } catch (error) {
        console.error("Error al obtener configFormData:", error);
        setConfigFormData(null);
      }
    })();
  }, [site]);

  // Función que obtiene los campos fuente de un KPI basándose en waterFormulasIndicators
  const getKPISourceFields = (kpiName) => {
    // Mapeo basado en la lógica real de waterFormulasIndicators
    const kpiSourceMap = {
      // KPIs con campo fuente directo
      water_domestic_municipal_network_kpis: [
        "water_domestic_municipal_network",
      ],
      municipal_network_water_production_kpis: [
        "municipal_network_water_production",
      ],
      domestic_groundwater_kpis: ["domestic_groundwater"],
      groundwater_production_kpis: ["groundwater_production"],
      rainwater_kpis: ["rainwater"],
      surface_water_kpis: ["surface_water"],
      recycled_water_kpis: ["recycled_water"],
      reused_water_kpis: ["reused_water"],
      steam_condensed_water_kpis: ["steam_condensed_water"],

      // KPIs calculados/agregados (no filtrar por campos individuales)
      total_water_production_kpis: null, // Agregación de múltiples campos de producción
      total_domestic_water_kpis: null, // Agregación de múltiples campos domésticos
      combined_total_water_kpis: null, // Agregación total
      total_production_water_per_unit_kpis: null, // Calculado
      total_domestic_water_per_employee_kpis: null, // Calculado
      total_combined_water_per_unit_kpis: null, // Calculado
      total_production_water_cost_per_unit_kpis: null, // Calculado
      total_domestic_water_cost_per_employee_kpis: null, // Calculado
      total_combined_water_cost_per_unit_kpis: null, // Calculado
      total_water_consumption_kpis: null, // Agregación total
    };

    return kpiSourceMap[kpiName];
  };

  // Determinar los campos únicos de indicadores y si tienen código
  // Filtra solo los campos que están activos en configFormData
  const determineFieldsKPIs = () => {
    const fields = new Set();

    Object.keys(waterKPIsCodes).forEach((key) => {
      const sourceFields = getKPISourceFields(key);

      // Si no tiene campos fuente (es un KPI calculado/agregado), siempre agregarlo
      if (sourceFields === null) {
        fields.add(key);
        return;
      }

      // Si hay configFormData, verificar si TODOS los campos fuente están activos
      if (configFormData?.fields && configFormData.fields.length > 0) {
        const allSourceFieldsActive = sourceFields.every((sourceFieldName) => {
          const fieldConfig = configFormData.fields.find(
            (f) => f.name === sourceFieldName,
          );
          return fieldConfig && fieldConfig.active !== false;
        });

        if (allSourceFieldsActive) {
          fields.add(key);
        }
      } else {
        // Si no hay configFormData, mostrar todos los campos (comportamiento por defecto)
        fields.add(key);
      }
    });

    return Array.from(fields);
  };

  // Determinar los campos únicos y si tienen código
  const determineFieldsCode = () => {
    const fields = new Set();

    Object.keys(waterCodes).forEach((key) => {
      fields.add(key);
    });

    return Array.from(fields);
  };

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        if (data && valueBaseline) {
          const previous_totals = await transformData1(data);

          calculateDataFinal(previous_totals);
          // Año actual
          const currentYear = new Date().getFullYear();

          // 🔹 Últimos 5 años dinámicos
          const lastFiveYears = [
            currentYear,
            currentYear - 1,
            currentYear - 2,
            currentYear - 3,
            currentYear - 4,
          ];

          // 🔹 Filtrar datos solo de esos 5 años
          const filteredByYears = data?.data
            ?.filter((item) => lastFiveYears.includes(Number(item.year))) // 👈 convierte el string
            ?.reduce((acc, item) => {
              const year = Number(item.year);
              if (!acc[year]) acc[year] = [];
              acc[year].push(item);
              return acc;
            }, {});

          // 🔹 Guardar solo años con al menos un mes cargado
          const yearsWithData = lastFiveYears.filter((year) =>
            data?.data?.some((item) => Number(item.year) === year)
          );
          setLastYears(yearsWithData);

          const results = await getLastThreeYearsData(filteredByYears);
          setTotalesByFilters(results);

          // Usar producción compartida desde DashBoard.js
          if (sharedProductionForms) {
            const totalesFinal = await calcularVPSVFSporMesPorAño(sharedProductionForms, baseline);
            setTotalesProductionsByFilters(totalesFinal);
          }
        }
      } catch (error) {
        //console.error(error);
      } finally {
        stopLoading();
      }
    })();
  }, [valueBaseline, configFormData, sharedProductionForms]);

  async function calcularVPSVFSporMesPorAño(documentosPorAño, baselines) {
    const resultado = {};

    for (const [year, docs] of Object.entries(documentosPorAño)) {
      const baselineType = baselines[year]; // "VPS" o "VFS"
      if (!baselineType) continue;

      const isProduccion = baselineType === "VPS";
      const prefix = isProduccion ? "VP" : "VF";

      resultado[year] = {};

      for (const doc of docs) {
        const mes = doc.period;
        if (!mes) continue;

        let totalMes = 0;

        // Recorremos todos los campos del documento
        for (const [key, campo] of Object.entries(doc)) {
          // buscamos solo los campos dinámicos de producción o facturación
          if (
            campo?.code &&
            campo.code.startsWith(prefix) &&
            !campo.code.startsWith(prefix + "S")
          ) {
            const value = Number(campo.value) || 0;
            const coef = Number(campo.standardized_coefficient) || 1;
            totalMes += value * coef;
          }
        }

        resultado[year][mes] = totalMes;
      }
    }

    return resultado;
  }

  //Calcula el valor de linea base por año hay que cambiar si es por vfs o vps
  const getValueBaseLine = async (year, type) => {
    try {
      if (type === "VPS") {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_production",
          );
        //setValueBaseline(response1.total)
        return response1.total;
      } else {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_billing",
          );
        //setValueBaseline(response1.total)
        return response1.total;
      }
    } catch (error) {
      //console.error(error);
      return 1;
    }
  };

  const transformData1 = async (data) => {
    // Inicializar el objeto de totales y los conceptos
    const totalsPerYear = {};
    const conceptsSet = [];
    const unitsCache = {}; // Aquí almacenaremos los datos de unidades por año

    // Unidades configuradas en configFormData tienen prioridad máxima
    const configUnits = {};
    if (configFormData?.fields && configFormData.fields.length > 0) {
      configFormData.fields.forEach((field) => {
        if (field.name && field.unit) {
          configUnits[field.name] = field.unit;
        }
      });
    }

    const fields = determineFieldsCode();

    // Verificar si data y data.data son válidos y contienen datos
    if (!data || !Array.isArray(data.data) || data.data.length === 0) {
      //console.log("No hay datos para procesar o data.data no es un array válido");
      return {}; // Retornar un objeto vacío o manejar el caso según se requiera
    }

    // Crear un array de años únicos de los datos de consumo
    const uniqueYears = [
      ...new Set(data.data.map((item) => String(item.year))),
    ];

    // Primero, obtener las unidades para todos los años requeridos
    //console.log('Obteniendo unidades para los años:', uniqueYears);
    const promises = uniqueYears.map(async (año) => {
      try {
        // Realizar la llamada para obtener las unidades para el año
        const units = await waterController.getLastUnitFieldsByYear(
          accessToken,
          site,
          año,
          fields,
        );

        // Guardar en el caché si las unidades son válidas
        if (units && units.fields) {
          unitsCache[año] = units;
          //console.log(`Unidades guardadas en caché para el año ${año}:`, units);
        } else {
          // console.log(`No se obtuvieron unidades válidas para el año ${año}`);
        }
      } catch (error) {
        //console.log(`Error al obtener unidades para el año ${año}:`, error);
      }
    });

    // Esperar a que todas las consultas de unidades se resuelvan
    await Promise.all(promises);

    // Ahora procesamos los datos de consumo usando las unidades en caché
    if (data.data !== undefined) {
      // Crear un array de promesas para manejar las llamadas asíncronas
      const consumptionPromises = data.data.map(async (item) => {
        const year = String(item.year);

        // Verificar si ya tenemos las unidades para este year en el caché
        const units = unitsCache[year];
        if (!units) {
          return;
        }

        // Iterar sobre los conceptos que tenemos en el item
        fields.forEach((concept) => {
          // Si el concepto existe, procesamos
          if (item[concept]) {
            // Añadir el concepto a la lista de concepts únicos
            conceptsSet.push(concept);

            // Inicializar el total para el year si no existe
            if (!totalsPerYear[concept]) {
              totalsPerYear[concept] = {};
            }

            // Inicializar el total para el year si no existe
            if (!totalsPerYear[concept][year]) {
              totalsPerYear[concept][year] = {
                total: 0,
                unit: configUnits[concept] || units.fields[concept] || item[concept]?.unit || "",
              };
            }

            // Sumar el valor de consumo
            totalsPerYear[concept][year].total += item[concept].value
              ? convertUnitsFinal(
                  item[concept].value,
                  item[concept].unit,
                  totalsPerYear[concept][year].unit,
                  concept,
                )
              : 0;
          }
        });
      });
      // Esperar a que todas las promesas de consumo se resuelvan
      await Promise.all(consumptionPromises);
    }

    return totalsPerYear;
  };

  const calculateDataFinal = async (totales) => {
    // Inicializar el objeto de totales y los conceptos
    const totalesFinal = { ...totales };
    const conceptosSet = [];

    if (totales !== undefined) {
      for (let item in totales) {
        if (totales.hasOwnProperty(item)) {
          for (let year in totales[item]) {
            // const valueB = await getValueBaseLine(year, baseline[year]);
            const valueB = valueBaseline[year];
            if (totales[item].hasOwnProperty(year)) {
              const fields = determineFieldsKPIs();

              // Iterar sobre los conceptos que tenemos en el item
              fields.forEach((concepto) => {
                // Añadir el concepto a la lista de conceptos únicos
                // Inicializar el total para el año si no existe
                if (!totalesFinal[concepto]) {
                  totalesFinal[concepto] = {};
                  conceptosSet.push(concepto);
                }

                // Inicializar el total para el año si no existe
                if (!totalesFinal[concepto][year]) {
                  totalesFinal[concepto][year] = {};
                }

                totalesFinal[concepto][year] = waterFormulasIndicators(
                  concepto,
                  year,
                  totalesFinal,
                  valueB === 0 ? 1 : valueB,
                  workersTotals[year],
                  // 1 ///TODO----falta cantidad de empleados
                );
              });
            }
          }
        }
      }
    }

    setConceptos(removeNulls(totalesFinal, conceptosSet));
    setTotales(totalesFinal);
  };

  /*
  const removeNulls = (data, conceptos) => {
    // Iterar sobre las claves externas
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        // Verificar si todos los valores internos son 0
        const allZero = Object.values(data[key]).every(
          (value) =>
            value?.total === 0 ||
            value?.total === undefined ||
            isNaN(value?.total) ||
            value === null ||
            value === false
        );

        // Si todos los valores son 0, eliminar la clave externa
        if (allZero) {
          conceptos = conceptos.filter((item) => item !== key);
        }
      }
    }
    return conceptos;
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

}*/
  // Función para obtener los valores de un año y mes específicos (period en texto)
  const getDataByYearAndMonth = async (data, year, month) => {
    const results = {};
    const fields = determineFieldsCode();
    //const fields = determineFieldsKPIs(); // ✅ función correcta

    // console.log("🔍 fields que se van a buscar:", fields);
    // console.log("🔍 data recibido:", data);
    const unitsCache = {};

    const configUnits = {};
    if (configFormData?.fields && configFormData.fields.length > 0) {
      configFormData.fields.forEach((field) => {
        if (field.name && field.unit) {
          configUnits[field.name] = field.unit;
        }
      });
    }

    if (!data || !data || Object.keys(data).length === 0) {
      return {};
    }

    // Diccionario de meses
    const monthMap = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    const yearStr = String(year);
    const monthStr =
      typeof month === "string"
        ? monthMap[month] || ""
        : String(month).padStart(2, "0");

    if (!monthStr) {
      //console.warn("Mes inválido o no reconocido:", month);
      return {};
    }

    const yearData = data[yearStr];
    if (!Array.isArray(yearData)) {
      //console.warn("No hay datos para el año:", yearStr);
      return {};
    }

    const filteredData = yearData.filter(
      (item) => monthMap[item.period] === monthStr,
    );

    if (filteredData.length === 0) {
      //console.warn(`No hay datos para ${month} ${yearStr}`);
      return {};
    }

    // Procesar resultados por campo
    filteredData.forEach((item) => {
      const units = unitsCache[yearStr];

      fields.forEach((concept) => {
        if (item[concept]) {
          if (!results[concept]) {
            results[concept] = {
              total: 0,
              unit: configUnits[concept] || units?.fields[concept] || item[concept]?.unit || "",
            };
          }

          results[concept].total += item[concept].value
            ? convertUnitsFinal(
                item[concept].value,
                item[concept].unit,
                results[concept].unit,
                concept,
              )
            : 0;
        }
      });
    });

    // ==========================
    // 🔹 AGREGAR: Calcular producción total
    // ==========================

    // Suponiendo que tienes campos de producción en tu data
    // Ajusta según tu estructura real de datos
    // let totalProduction = 0;
    // let productionUnit = "";

    // // Si tienes producción en los datos mensuales
    // filteredData.forEach((item) => {
    //   if (item.productionUnit) {
    //     // 👈 ajusta el nombre del campo según tu estructura
    //     totalProduction += item.production.value || 0;
    //     productionUnit = item.production.unit || productionUnit;
    //   }
    // });

    // results.production = {
    //   total: totalProduction,
    //   unit: productionUnit || "L", // 👈 ajusta la unidad por defecto
    // };

    // Lista de conceptos de agua (sin costos)
    const waterConcepts = Object.keys(waterCodes).filter(
      (key) => !key.includes("cost"),
    );

    // Unidad estándar para sumar todos los conceptos de agua
    const standardUnit = "m3";
    let totalWaterMonth = 0;

    waterConcepts.forEach((concept) => {
      if (results[concept] && typeof results[concept].total === "number") {
        // Convertir cada valor a la unidad estándar antes de sumar
        const convertedValue = convertUnitsFinal(
          results[concept].total,
          results[concept].unit,
          standardUnit,
          concept,
        );
        totalWaterMonth += convertedValue;
      }
    });

    results.total_water_month = {
      total: totalWaterMonth,
      unit: standardUnit,
    };

    return results;
  };

  // ==========================
  // 🔹 Calcular ultimos 5 años
  // ==========================

  const getLastThreeYearsData = async (totalesByFilters) => {
    const currentYear = new Date().getFullYear();
    const lastFiveYears = [
      currentYear - 4,
      currentYear - 3,
      currentYear - 2,
      currentYear - 1,
      currentYear,
    ];

    const resultsByYear = {};

    for (const year of lastFiveYears) {
      resultsByYear[year] = {};

      for (const month of months) {
        const data = await getDataByYearAndMonth(totalesByFilters, year, month);
        resultsByYear[year][month] = data;
      }
    }
    return resultsByYear;
  };

  const removeNulls = (data, concepts) => {
    // Iterar sobre las claves externas
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        // Verificar si todos los valores internos son 0, null, undefined o NaN
        const allZero = Object.values(data[key]).every((value) => {
          // Si el valor es un objeto con propiedad total
          if (value && typeof value === "object" && "total" in value) {
            const total = value.total;
            return (
              total === 0 ||
              total === null ||
              total === undefined ||
              isNaN(total)
            );
          }
          // Si el valor no es un objeto válido
          return true;
        });

        // Si todos los valores son 0, eliminar la clave externa
        if (allZero) {
          concepts = concepts.filter((item) => item !== key);
        }
      }
    }
    return concepts;
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (
    !data ||
    !data.years ||
    data.years.length === 0 ||
    !conceptos ||
    conceptos.length === 0
  ) {
    return (
      <div style={{ textAlign: "center", padding: "5em 0", color: "#777" }}>
        <div style={{ fontSize: "2em", marginBottom: "1em", color: "#ccc" }}>
          <Icon name="exclamation triangle" size="huge" color="gray" />
        </div>
        <div
          style={{ fontSize: "1.5em", fontWeight: "bold", marginBottom: "1em" }}
        >
          {t("no_data_available") || "No hay datos disponibles"}
        </div>
      </div>
    );
  } else {
    return (
      <div className="list-water-forms">
        {/* Sección de Resumen */}
        <div className="water-summary-section">
          <WaterSummary
            filters={filters}
            site={site}
            valueBaseline={valueBaseline}
            waterController={Waterform}
            totales={totalesByFilters}
            workersTotals={workersTotals}
            selectorSlot={<YearMonthSelector onChange={setFilters} />}
          />
        </div>

        {/* Sección de Gráficos */}
        <div className="water-tablegraf-section">
          <TableGraf filters={filters} totales={totales} t={t} />
        </div>

        {/* Sección de Comparación */}
        <CollapsibleSection
          title={t("water_total_consumption_comparison_3_years")}
          className="water-comparison-section"
        >
          <WaterComparisonChart resultsByYear={totalesByFilters} t={t} />
        </CollapsibleSection>

        {/* Sección de Intensidad Industrial */}
        <CollapsibleSection
          title={t("industrial_water_intensity")}
          className="water-intensity-section"
        >
          <WaterProductionIntensityChart
            resultsByYear={totalesByFilters}
            t={t}
            filters={filters}
            resultsProductions={totalesProductionsByFilters}
          />
        </CollapsibleSection>

        {/* Sección de Intensidad Doméstica */}
        <CollapsibleSection
          title={t("domestic_water_intensity")}
          className="water-intensity-section"
        >
          <WaterDomesticIntensityChart
            resultsByYear={totalesByFilters}
            t={t}
            filters={filters}
            resultsWorkers={workersTotalsByPeriod}
          />
        </CollapsibleSection>

        {/* Sección de Tabla de Datos */}
        <CollapsibleSection
          className="water-table-section"
          header={
            <div className="water-table-col-header">
              <span className="col-code">{t("code")}</span>
              <span className="col-indicators">{t("indicators")}</span>
              <span className="col-years">
                {(data.years
                  ? [...data.years].sort((a, b) => b - a).slice(0, 5)
                  : []
                ).map((y) => (
                  <span key={y} className="col-year">{y}</span>
                ))}
              </span>
              <span className="col-lb">{t("LB")}</span>
              <span className="col-units">{t("units")}</span>
            </div>
          }
          defaultOpen={true}
        >
          <TableYears
            filters={filters}
            data={data}
            accessToken={accessToken}
            t={t}
            conceptos={conceptos}
            totales={totales}
            language={language}
            indicatorsLineBase={indicatorsLineBase}
            valueBaseline={valueBaseline}
          />
        </CollapsibleSection>

        {/* Sección de Valores Intermedios */}
        {/* <div className="water-intermediate-section"> */}
        <IntermediateValuesDisplay
          resultsProductions={totalesProductionsByFilters}
          resultsWorkers={workersTotalsByPeriod}
          t={t}
        />
        {/* </div> */}
      </div>
    );
  }
}
function TableYears(props) {
  const { data, conceptos, totales, t, language, indicatorsLineBase, filters } =
    props;
  const { year, month } = filters || {};
  const [years, setYears] = useState([]);
  const [listConceptos, setListConceptos] = useState([]);
  const [months, setMoths] = useState([]);

  //const [uniqueFields, setUniqueFields] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);

  // Función para manejar cambios de unidad (comentada para uso futuro)
  /*const handleUnitChange = (rowIndex, newValue) => {
    setSelectedUnits({ ...selectedUnits, [rowIndex]: newValue.value });
  };*/

  // useEffect(() => {
  //   console.log("📊 TableGraf filtrando con:", { year, month });
  // }, [year, month]);

  useEffect(() => {
    (async () => {
      try {
        setYears(data.years ? data.years.sort((a, b) => b - a).slice(0, 5) : []);
      } catch (error) {
        //console.error(error);
      }
    })();
  }, [data]);

  useEffect(() => {
    (async () => {
      try {
        // Obtener todos los campos únicos

        let valor = {};
        conceptos.map(
          (field) => (valor[field] = obtenerUnidadDeOtrosAnios(totales, field)),
          // (field) => (valor[field] = determineWaterUnits(field)[0].value)
        );

        setSelectedUnits(valor);
      } catch (error) {
        // console.error(error);
        setSelectedUnits([]);
      }
    })();
  }, [totales]);

  useEffect(() => {
    (async () => {
      try {
        setListConceptos(conceptos);
      } catch (error) {
        //console.error(error);
      }
    })();
  }, [conceptos]);

  // Buscar el primer año que tenga unidad definida
  const obtenerUnidadDeOtrosAnios = (datos, concepto) => {
    if (!datos[concepto]) return "";
    const años = Object.keys(datos[concepto]);
    const añoConUnidad = años.find((año) => datos[concepto][año]?.unit);
    return añoConUnidad ? datos[concepto][añoConUnidad].unit : "";
  };

  const getIndicators = (item) => {
    let result = indicatorsLineBase.find((value) => value.name === item);
    if (result) {
      return result?.yearBaseline || 0;
    }
    return 0; // Sin cambio
  };

  // Determina si una fila debe mostrarse como enteros (sin decimales)
  const isIntegerRow = (item) => {
    return item.includes("cost");
  };

  // Determina los decimales necesarios para un valor individual
  // Muestra siempre 2 dígitos significativos después de los ceros iniciales
  // Ej: 0.00447 → 4 decimales → "0.0045", 0.0447 → 3 decimales → "0.045"
  const getNeededDecimals = (value) => {
    if (typeof value !== "number" || isNaN(value) || value === 0) return 2;
    const abs = Math.abs(value);
    if (abs < 0.0000005) return -1; // demasiado pequeño → mostrar 0
    if (abs >= 1) return 2;
    // Contar ceros iniciales después del punto decimal y agregar 2 dígitos
    const leadingZeros = Math.floor(-Math.log10(abs));
    return Math.max(2, leadingZeros + 2);
  };

  // Determina la cantidad de decimales consistente para toda una fila
  const getRowDecimalPlaces = (item, values) => {
    const nonZero = values.filter(
      (v) => typeof v === "number" && !isNaN(v) && v !== 0,
    );
    if (isIntegerRow(item)) {
      // Costos: enteros si todos los valores son >= 1; si hay valores < 1 aplica umbrales
      if (nonZero.length === 0 || nonZero.every((v) => Math.abs(v) >= 1))
        return 0;
    }
    let maxDecimals = 2;
    for (const v of values) {
      if (typeof v !== "number" || isNaN(v) || v === 0) continue;
      const needed = getNeededDecimals(v);
      if (needed === -1) continue;
      if (needed > maxDecimals) maxDecimals = needed;
    }
    return Math.min(maxDecimals, 6);
  };

  // Formatea un valor con la cantidad de decimales determinada para la fila
  const formatWithDecimals = (value, decimals) => {
    if (typeof value !== "number" || isNaN(value)) return "-";
    if (value === 0) return "-";
    if (Math.abs(value) < 0.0000005)
      return decimals === 0 ? "0" : (0).toFixed(decimals);
    if (decimals === 0) return Math.round(value).toString();
    return value.toFixed(decimals);
  };

  // Renderiza una píldora de comparativa rojo/verde
  const renderPill = (value, prevValue, decimals) => {
    const numValue = value != null ? Number(value) : null;
    const numPrev = prevValue != null ? Number(prevValue) : null;

    if (numValue == null || numValue === 0) {
      return <span className="gei-value-pill pill-empty" />;
    }

    let pillClass;
    if (numPrev == null || numPrev === 0) {
      pillClass = "pill-neutral";
    } else if (numValue > numPrev) {
      pillClass = "pill-up";
    } else if (numValue < numPrev) {
      pillClass = "pill-down";
    } else {
      pillClass = "pill-neutral";
    }

    return (
      <span className={`gei-value-pill ${pillClass}`}>
        {formatWithDecimals(numValue, decimals)}
      </span>
    );
  };
  return (
    <>
      <Table celled structured size="small" className="gei-kpi-table">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("code")}
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("indicators")}
            </Table.HeaderCell>
            {years.map((year, index) => (
              <Table.HeaderCell rowSpan="2" textAlign="center" key={index}>
                {year}
              </Table.HeaderCell>
            ))}
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("LB")}
            </Table.HeaderCell>
            <Table.HeaderCell
              rowSpan="2"
              textAlign="center"
              style={{ width: "200px" }}
            >
              {t("units")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {conceptos.map((item, index) => {
            // Recopilar todos los valores de la fila para determinar decimales consistentes
            const rowValues = years
              .map(y => {
                const raw = totales[item]?.[y]?.total || 0;
                return convertUnitsFinal(
                  raw,
                  totales[item]?.[y]?.unit,
                  selectedUnits[item],
                  selectedUnits,
                );
              })
              .filter(v => typeof v === "number" && !isNaN(v));
            const lbRaw = convertUnitsFinal(
              totales[item]?.[getIndicators(item)]?.total || 0,
              totales[item]?.[getIndicators(item)]?.unit,
              selectedUnits[item],
              selectedUnits,
            );
            if (typeof lbRaw === "number" && !isNaN(lbRaw)) rowValues.push(lbRaw);

            const rowDecimals = getRowDecimalPlaces(item, rowValues);

            return (
            <React.Fragment key={index}>
              <Table.Row>
                <Table.Cell>{waterKPIsCodes[item]}</Table.Cell>
                <Table.Cell>{t(item)}</Table.Cell>
                {years.map((year, i) => {
                  if (totales[item]) {
                    const rawValue = convertUnitsFinal(
                      totales[item][year]?.total || 0,
                      totales[item][year]?.unit,
                      selectedUnits[item],
                      selectedUnits,
                    );
                    const prevRawValue = convertUnitsFinal(
                      totales[item][years[i + 1]]?.total || 0,
                      totales[item][years[i + 1]]?.unit,
                      selectedUnits[item],
                      selectedUnits,
                    );
                    const pill = renderPill(rawValue, prevRawValue, rowDecimals);
                    return (
                      <Table.Cell key={i} textAlign="center">
                        <Popup
                          content={`Valor real: ${parseFloat(Number(totales[item][year]?.total || 0).toFixed(6))} ${totales[item][year]?.unit || selectedUnits[item]}`}
                          trigger={<span style={{ cursor: "help" }}>{pill}</span>}
                          position="top center"
                          size="tiny"
                        />
                      </Table.Cell>
                    );
                  }
                  return <Table.Cell key={i}>{""}</Table.Cell>;
                })}
                <Table.Cell>
                  <Popup
                    content={`Valor real: ${parseFloat(Number(totales[item][getIndicators(item)]?.total || 0).toFixed(6))} ${totales[item][getIndicators(item)]?.unit || selectedUnits[item]}`}
                    trigger={
                      <span style={{ cursor: "help" }}>
                        {formatWithDecimals(lbRaw, rowDecimals)}
                      </span>
                    }
                    position="top center"
                    size="tiny"
                  />
                </Table.Cell>
                <Table.Cell>
                  {selectedUnits[item]
                    ? item.includes("per_employee") ||
                      item.includes("water_domestic_municipal_network_kpis") ||
                      item.includes("domestic_groundwater_kpis")
                      ? `${selectedUnits[item]} / ${t("employee")}`
                      : item.includes("per_unit") ||
                          item.includes(
                            "municipal_network_water_production_kpis",
                          ) ||
                          item.includes("groundwater_production_kpis") ||
                          item.includes("rainwater_kpis") ||
                          item.includes("surface_water_kpis") ||
                          item.includes("recycled_water_kpis") ||
                          item.includes("reused_water_kpis") ||
                          item.includes("steam_condensed_water_kpis")
                        ? `${selectedUnits[item]} / ${t("unit")}`
                        : selectedUnits[item]
                    : "-"}
                  {/* Dropdown para convertir unidades (comentado para uso futuro)
                  <Dropdown
                    onChange={(e, data) => {
                      handleUnitChange(item, data);
                    }}
                    options={determineWaterUnits(item).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    search
                    inline
                    style={{ width: "100%" }}
                    value={selectedUnits[item]}
                  />
                  */}
                </Table.Cell>
              </Table.Row>
            </React.Fragment>
            );
          })}
        </Table.Body>
      </Table>
    </>
  );
}

export const YearMonthSelector = ({ onChange }) => {
  const currentYear = new Date().getFullYear();

  const years = [
    { key: currentYear, text: currentYear, value: currentYear },
    { key: currentYear - 1, text: currentYear - 1, value: currentYear - 1 },
    { key: currentYear - 2, text: currentYear - 2, value: currentYear - 2 },
    { key: currentYear - 3, text: currentYear - 3, value: currentYear - 3 },
    { key: currentYear - 4, text: currentYear - 4, value: currentYear - 4 },
  ];

  const months = [
    { key: 1, text: "Enero", value: 1 },
    { key: 2, text: "Febrero", value: 2 },
    { key: 3, text: "Marzo", value: 3 },
    { key: 4, text: "Abril", value: 4 },
    { key: 5, text: "Mayo", value: 5 },
    { key: 6, text: "Junio", value: 6 },
    { key: 7, text: "Julio", value: 7 },
    { key: 8, text: "Agosto", value: 8 },
    { key: 9, text: "Septiembre", value: 9 },
    { key: 10, text: "Octubre", value: 10 },
    { key: 11, text: "Noviembre", value: 11 },
    { key: 12, text: "Diciembre", value: 12 },
  ];

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // 1-12

  const handleYearChange = (e, { value }) => {
    setSelectedYear(value);
    onChange({ year: value });
  };

  return (
    <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
      <Dropdown
        placeholder="Año"
        selection
        options={years}
        value={selectedYear}
        onChange={handleYearChange}
        className="year-filter-dropdown"
      />
    </div>
  );
};

///Grafico de comparacion consumo ultimos 3 años
function WaterComparisonChart({ resultsByYear, t }) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Object.keys(resultsByYear)
    .map(Number) // convertir a número
    .sort((a, b) => a - b) // ordenar ascendente
    .slice(-3) // quedarte con los 3 últimos
    .map(String); // volver a string si lo necesitás

  // ✅ 🌊 Calcular los datos solo cuando cambien resultsByYear
// ✅ 🌊 Calcular los datos solo cuando cambien resultsByYear
  const { barData, lineData } = useMemo(() => {
    const bar = [];
    const line = [];

    years.forEach((year) => {
      // 1. Obtener todos los valores del año
      const values = months.map(
        (month) =>
          resultsByYear?.[year]?.[month]?.total_water_month?.total || 0,
      );

      // 2. 💡 CÁLCULO DINÁMICO DEL PROMEDIO
      // Filtramos solo los meses que tienen datos (> 0)
      const monthsWithData = values.filter(v => v > 0);
      
      // Si el año es el actual, dividimos por los meses transcurridos con datos.
      // Si es un año pasado, generalmente dividimos por 12 (o por meses con datos si hubo meses sin consumo real)
      const currentYear = new Date().getFullYear().toString();
      const divisor = year === currentYear 
        ? (monthsWithData.length || 1) 
        : 12; 

      const totalSum = values.reduce((a, b) => a + b, 0);
      const avg = totalSum / divisor;

      months.forEach((month, i) => {
        const total = values[i];

        // Solo agregamos al gráfico de barras si hay consumo (para no llenar de barras vacías)
        if (total > 0) {
          bar.push({
            year: String(year),
            month: t(month),
            value: total,
            type: "Consumo",
          });
        }

        // La línea de promedio sí debe existir para todos los meses para que sea continua
        line.push({
          year: String(year),
          month: t(month),
          value: avg,
          type: "Promedio",
        });
      });
    });

    // ... (resto de tu lógica de sortData se mantiene igual)
    const sortData = (arr) => {
      return arr.sort((a, b) => {
        if (a.year !== b.year) return Number(b.year) - Number(a.year);
        if (a.type === "Promedio" && b.type === "Consumo") return -1;
        if (a.type === "Consumo" && b.type === "Promedio") return 1;
        return 0;
      });
    };

    return {
      barData: sortData(bar),
      lineData: sortData(line),
    };
  }, [resultsByYear, years, t]);
  // Renderizador de la leyenda estilo "Pills"
const CustomLegend = () => (
  <div style={{
    display: "flex",
    justifyContent: "flex-start", // 👈 Alinea a la izquierda
    gap: "10px",
    marginBottom: "20px",
    paddingLeft: "5px", // Ajusta según el padding de tu contenedor de gráfico
    flexWrap: "wrap",
  }}>
    {years.map((year) => {
      const isActive = activeYears.includes(year);
      return (
        <div
          key={year}
          onClick={() => toggleYear(year)}
          style={{
            backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6", 
            color: isActive ? "white" : "#9ca3af",
            padding: "4px 20px", // Un poco más compacto
            borderRadius: "20px",
            fontSize: "13px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s ease-in-out",
            border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
            boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
            userSelect: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth:"100px"
          }}
        >
          {year}
        </div>
      );
    })}
  </div>
);

const [activeYears, setActiveYears] = useState(years); 

// Función para alternar años
const toggleYear = (year) => {
  if (activeYears.includes(year)) {
    // Si solo queda uno, podrías elegir no dejar que se desactive el último
    setActiveYears(activeYears.filter(y => y !== year));
  } else {
    setActiveYears([...activeYears, year]);
  }
};

const filteredBarData = useMemo(() => 
  barData.filter(d => activeYears.includes(String(d.year))), 
[barData, activeYears]);

const filteredLineData = useMemo(() => 
  lineData.filter(d => activeYears.includes(String(d.year))), 
[lineData, activeYears]);
  // 🔹 Leer colores desde CSS
const getCssVar = (name) =>
  getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();

const chartColors = {
  oldest: getCssVar("--chart-year-oldest"),
  prev: getCssVar("--chart-year-prev"),
  last: getCssVar("--chart-year-last"),
  avg: getCssVar("--chart-avg-line"),
};

// 1. Mapear años → colores fijos (Asegúrate de que esto esté actualizado)
const yearColorMap = useMemo(() => {
  const sorted = [...years].map(Number).sort((a, b) => a - b);
  return {
    [sorted[0]]: chartColors.oldest || "#cbd5e1", // Fallback si el CSS no carga
    [sorted[1]]: chartColors.prev || "#94a3b8",
    [sorted[2]]: chartColors.last || "#1e293b",
  };
}, [years, chartColors]);

  const config = {
    xField: "month",
    legend:false,
   scale: {
    color: {
      domain: Object.keys(yearColorMap),
      range: Object.values(yearColorMap),
    },
      y: { sync: true, nice: true, domainMin: 0 },
  },
    tooltip: {
      items: [
        (item) => {
          // Cambiar el marcador para Promedio
          const marker = item.type?.includes("Promedio") ? "- -" : "";
          return {
            name: `${marker} ${item.type}`,
            value: item.value.toFixed(2),
          };
        },
      ],
    },
    axis: {
      // x: { title: "month" },
      y: { labelFormatter: "~s" },
    },
    // legend: {
    //     position: "bottom"
    //   },
    children: [
      {
              data: filteredBarData, // <--- Datos filtrados
        type: "interval",
        yField: "value",
        colorField: "year",
        seriesField: "year", // 🔹 esto separa las barras por  año
        group: true,
        dodgePadding: 2,      //  evita que sobresalga
      intervalPadding: 4,   //  separa columnas y evita “salida” del eje
       scale: {
        color: ({ year }) => yearColorMap[year], // 👈 ACA
    },
      },
      {
        data: filteredLineData,
        type: "line",
        yField: "value",
        colorField: "year",
         style: {lineWidth: 2,
        lineDash: [4, 8] },
         axis: { y: false },
      // axis: { y: { position: "right" } },
      // scale: { series: { independent: true } },
      interaction: {
        tooltip: {
          crosshairs: false,
          marker: false,
        },
      },
      },
    ],
    axis: {
  x: {
    title: false,
    labelAutoHide: false,
    labelAutoRotate: false,
  },
  y: {
      title: false, // Un solo eje Y a la izquierda
      grid: true,
    }}
  };
  return (
    <div style={{ height: 350, marginTop: 20, marginBottom: 20 }}>
      {/* 🟢 NUEVA LEYENDA ESTILO IMAGEN */}
    {barData.length > 0 && <CustomLegend />}
      {barData.length > 0 ? <DualAxes {...config} /> : <p>Cargando datos...</p>}
    </div>
  );
}

//Grafico de intensidad de produccion ultimos 3 años
function WaterProductionIntensityChart({
  resultsByYear,
  t,
  resultsProductions,
}) {
  const years = Object.keys(resultsByYear)
    .map(Number) // convertir a número
    .sort((a, b) => a - b) // ordenar ascendente
    .slice(-3) // quedarte con los 3 últimos
    .map(String); // volver a string si lo necesitás
const { consumptionData, averageData } = useMemo(() => {
  const cData = [];
  const aData = [];

  years.forEach((year) => {
    const totals = months.map((m) => {
      const totalWaterMonth = resultsByYear?.[year]?.[m] || {};
      
      // Suma de consumos
      const energy = 
        convertUnitsFinal(totalWaterMonth.municipal_network_water_production?.total, totalWaterMonth.municipal_network_water_production?.unit, "l") +
        convertUnitsFinal(totalWaterMonth.groundwater_production?.total, totalWaterMonth.groundwater_production?.unit, "l") +
        convertUnitsFinal(totalWaterMonth.surface_water?.total, totalWaterMonth.surface_water?.unit, "l") +
        convertUnitsFinal(totalWaterMonth.distilled_water?.total, totalWaterMonth.distilled_water?.unit, "l") +
        convertUnitsFinal(totalWaterMonth.reused_water?.total, totalWaterMonth.reused_water?.unit, "l") +
        convertUnitsFinal(totalWaterMonth.recycled_water?.total, totalWaterMonth.recycled_water?.unit, "l") +
        convertUnitsFinal(totalWaterMonth.steam_condensed_water?.total, totalWaterMonth.steam_condensed_water?.unit, "l");

      const production = resultsProductions?.[year]?.[m] || 0;

      // 💡 CAMBIO AQUÍ: Si la intensidad es 0, devolvemos null para que la línea se rompa
      const intensity = (production > 0 && energy > 0) ? (energy / production) : null;
      return intensity;
    });

    // Calcular promedio ignorando los nulls
    const validValues = totals.filter(v => v !== null);
    const avg = validValues.length > 0 
      ? validValues.reduce((a, b) => a + b, 0) / validValues.length 
      : null;

    months.forEach((month, i) => {
      const total = totals[i];
      
      // Solo agregamos al dataset si queremos que el eje X exista, 
      // pero el valor 'null' hará que la línea no se pinte.
      cData.push({
        year,
        month: t(month),
        value: total, // será un número o null
        type: "Consumo",
      });

      aData.push({
        year,
        month: t(month),
        value: avg,
        type: "Promedio",
      });
    });
  });

  return { consumptionData: cData, averageData: aData };
}, [resultsByYear, resultsProductions, t]);
    // Renderizador de la leyenda estilo "Pills"
  const CustomLegend = () => (
    <div style={{
      display: "flex",
      justifyContent: "flex-start", // 👈 Alinea a la izquierda
      gap: "10px",
      marginBottom: "20px",
      paddingLeft: "5px", // Ajusta según el padding de tu contenedor de gráfico
      flexWrap: "wrap",
    }}>
      {years.map((year) => {
        const isActive = activeYears.includes(year);
        return (
          <div
            key={year}
            onClick={() => toggleYear(year)}
            style={{
              backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6", 
              color: isActive ? "white" : "#9ca3af",
              padding: "4px 20px", // Un poco más compacto
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
              boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth:"100px"
            }}
          >
            {year}
          </div>
        );
      })}
    </div>
  );
  
  // Dentro de tu componente FuelsComparisonChart
  const [activeYears, setActiveYears] = useState(years); 
  
  // Función para alternar años
  const toggleYear = (year) => {
    if (activeYears.includes(year)) {
      // Si solo queda uno, podrías elegir no dejar que se desactive el último
      setActiveYears(activeYears.filter(y => y !== year));
    } else {
      setActiveYears([...activeYears, year]);
    }
  };
  
  const filteredConsumptionData = useMemo(() => 
    consumptionData.filter(d => activeYears.includes(String(d.year))), 
  [consumptionData, activeYears]);
  
  const filteredAverageData = useMemo(() => 
    averageData.filter(d => activeYears.includes(String(d.year))), 
  [averageData, activeYears]);
    // 🔹 Leer colores desde CSS
  const getCssVar = (name) =>
    getComputedStyle(document.documentElement)
      .getPropertyValue(name)
      .trim();
  
  const chartColors = {
    oldest: getCssVar("--chart-year-oldest"),
    prev: getCssVar("--chart-year-prev"),
    last: getCssVar("--chart-year-last"),
    avg: getCssVar("--chart-avg-line"),
  };
  ;
  
  // 1. Mapear años → colores fijos (Asegúrate de que esto esté actualizado)
  const yearColorMap = useMemo(() => {
    const sorted = [...years].map(Number).sort((a, b) => a - b);
    return {
      [sorted[0]]: chartColors.oldest || "#cbd5e1", // Fallback si el CSS no carga
      [sorted[1]]: chartColors.prev || "#94a3b8",
      [sorted[2]]: chartColors.last || "#1e293b",
    };
  }, [years, chartColors]);

  const config = {
    xField: "month",
      scale: {
    color: {
      domain: Object.keys(yearColorMap),
      range: Object.values(yearColorMap),
    },
  },
    tooltip: {
  items: [
    (item) => {
      // 1. Manejo para ítems con nombre (si existen)
      if (item.name) {
        return {
          name: item.name,
          value: item.count,
          color: yearColorMap[item.year],
        };
      }

      // 2. VALIDACIÓN CLAVE: Si el valor es null o undefined, no ejecutamos toFixed
      if (item.value === null || item.value === undefined) {
        return {
          name: item.type,
          value: "-", // O lo que prefieras mostrar cuando no hay datos
        };
      }

      // 3. Manejo para Promedio y Consumo con datos válidos
      const marker = item.type?.includes("Promedio") ? "- -" : "";
      return {
        name: `${marker} ${item.type}`,
        value: typeof item.value === 'number' ? item.value.toFixed(2) : item.value,
      };
    },
  ],
},
    legend:false,
    children: [
      {
        data: filteredConsumptionData,
        type: "line",
        yField: "value",
        colorField: "year",
       // seriesField: "year",
        style: { lineWidth: 4 },
               connectNulls: false,
      },
      {
        data: filteredAverageData,
        type: "line",
        yField: "value",
        colorField: "year",
                 axis: { y: false },
        style: {lineWidth: 2,
        lineDash: [4, 8] },
           connectNulls: false,
      },
    ],
  };

  return (
    <div style={{ height: 450, marginTop: 20, marginBottom: 20 }}>
         {/* 🟢 NUEVA LEYENDA ESTILO IMAGEN */}
    {consumptionData.length > 0 && <CustomLegend />}
      {consumptionData.length ? (
             <DualAxes {...config} style={{ height: 400 }} />
           ) : (
             <div style={{
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
               height: 400,
               color: "#999",
             }}>
               No hay datos disponibles
             </div>
           )}
    </div>
  );
}

//Grafico de intensidad domestica ultimos 3 años
function WaterDomesticIntensityChart({ resultsByYear, t, resultsWorkers }) {
  const years = Object.keys(resultsByYear)
    .map(Number) // convertir a número
    .sort((a, b) => a - b) // ordenar ascendente
    .slice(-3) // quedarte con los 3 últimos
    .map(String); // volver a string si lo necesitás

  // ✅ useMemo garantiza nueva referencia cuando cambia resultsByYear
  const { consumptionData, averageData } = useMemo(() => {
    const cData = [];
    const aData = [];

    years.forEach((year) => {
      const totals = months.map((m) => {
        // ✅ Sumar los campos específicos de producción de agua
        const totalWaterMonth = resultsByYear?.[year]?.[m] || {};
        const energy =
          convertUnitsFinal(
            totalWaterMonth.water_domestic_municipal_network?.total,
            totalWaterMonth.water_domestic_municipal_network?.unit,
            "l",
          ) +
          convertUnitsFinal(
            totalWaterMonth.domestic_groundwater?.total,
            totalWaterMonth.domestic_groundwater?.unit,
            "l",
          ) +
          convertUnitsFinal(
            totalWaterMonth.rainwater?.total,
            totalWaterMonth.rainwater?.unit,
            "l",
          );

        // ✅ Si ya viene como número (1, 2, 3, 4…)
        const production = resultsWorkers?.[year]?.[m] || 0;

        // Evitar división por 0
        return production > 0 ? energy / production : 0;
      });

      const avg =
        totals.length > 0
          ? totals.reduce((a, b) => a + b, 0) / totals.length
          : 0;

      months.forEach((month, i) => {
        const total = totals[i];
        cData.push({
          year,
          month: t(month),
          value: total,
          type: "Consumo",
        });
        aData.push({
          year,
          month: t(month),
          value: avg,
          type: "Promedio",
        });
      });
    });

    return { consumptionData: cData, averageData: aData };
  }, [resultsByYear, resultsWorkers]); // 👈 se recalcula solo cuando cambian los datos

  
    // Renderizador de la leyenda estilo "Pills"
  const CustomLegend = () => (
    <div style={{
      display: "flex",
      justifyContent: "flex-start", // 👈 Alinea a la izquierda
      gap: "10px",
      marginBottom: "20px",
      paddingLeft: "5px", // Ajusta según el padding de tu contenedor de gráfico
      flexWrap: "wrap",
    }}>
      {years.map((year) => {
        const isActive = activeYears.includes(year);
        return (
          <div
            key={year}
            onClick={() => toggleYear(year)}
            style={{
              backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6", 
              color: isActive ? "white" : "#9ca3af",
              padding: "4px 20px", // Un poco más compacto
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
              boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth:"100px"
            }}
          >
            {year}
          </div>
        );
      })}
    </div>
  );
  
  // Dentro de tu componente FuelsComparisonChart
  const [activeYears, setActiveYears] = useState(years); 
  
  // Función para alternar años
  const toggleYear = (year) => {
    if (activeYears.includes(year)) {
      // Si solo queda uno, podrías elegir no dejar que se desactive el último
      setActiveYears(activeYears.filter(y => y !== year));
    } else {
      setActiveYears([...activeYears, year]);
    }
  };
  
  const filteredConsumptionData = useMemo(() => 
    consumptionData.filter(d => activeYears.includes(String(d.year))), 
  [consumptionData, activeYears]);
  
  const filteredAverageData = useMemo(() => 
    averageData.filter(d => activeYears.includes(String(d.year))), 
  [averageData, activeYears]);
    // 🔹 Leer colores desde CSS
  const getCssVar = (name) =>
    getComputedStyle(document.documentElement)
      .getPropertyValue(name)
      .trim();
  
  const chartColors = {
    oldest: getCssVar("--chart-year-oldest"),
    prev: getCssVar("--chart-year-prev"),
    last: getCssVar("--chart-year-last"),
    avg: getCssVar("--chart-avg-line"),
  };
  ;
  
  // 1. Mapear años → colores fijos (Asegúrate de que esto esté actualizado)
  const yearColorMap = useMemo(() => {
    const sorted = [...years].map(Number).sort((a, b) => a - b);
    return {
      [sorted[0]]: chartColors.oldest || "#cbd5e1", // Fallback si el CSS no carga
      [sorted[1]]: chartColors.prev || "#94a3b8",
      [sorted[2]]: chartColors.last || "#1e293b",
    };
  }, [years, chartColors]);
  

  // 🔹 Config del gráfico
  const config = {
    xField: "month",
      // 🔹 Escala global de colores para ambas capas
  scale: {
    color: {
      domain: Object.keys(yearColorMap),
      range: Object.values(yearColorMap),
    },
  },
       tooltip: {
      items: [
        (item) => ({
        name: item.type,
        value: item.value.toLocaleString("en-US", { 
          minimumFractionDigits: 3, 
          maximumFractionDigits: 3 
        }),
        color: yearColorMap[item.year],
      }),
      ],
    },
    legend:false,
    children: [
      {
        data: filteredConsumptionData,
        type: "line",
        yField: "value",
        colorField: "year",
        group: true,
        style: { maxWidth: 80, lineWidth: 4 },
     connectNulls: false,
      },
      {
        data: filteredAverageData,
        type: "line",
        yField: "value",
        colorField: "year",

          axis: { y: false },
      style: {
        lineWidth: 2,
        lineDash: [4, 8],
      },
         connectNulls: false,
      },
    ],
  };

  return (
    <div style={{ height: 450, marginTop: 20, marginBottom: 20 }}>
       {/* 🟢 NUEVA LEYENDA ESTILO IMAGEN */}
          {consumptionData.length > 0 && <CustomLegend />}
      
            {consumptionData.length ? (
              <DualAxes {...config} style={{ height: 400 }} />
            ) : (
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: 400,
                color: "#999",
              }}>
                No hay datos disponibles
              </div>
            )}
    </div>
  );
}

// Componente para mostrar valores intermedios utilizados en los cálculos
function IntermediateValuesDisplay({ resultsProductions, resultsWorkers, t }) {
  const [isOpen, setIsOpen] = useState(false);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Obtener todos los años disponibles y ordenarlos de mayor a menor
  const availableYears = Object.keys(resultsProductions || {}).sort(
    (a, b) => b - a,
  );

  return (
    <div
      style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        border: "1px solid #dee2e6",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          padding: "10px 0",
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h4 style={{ margin: 0, color: "#495057" }}>
          <Icon name={isOpen ? "chevron down" : "chevron right"} />
          Valores intermedios para verificación de cálculos - Últimos 5 años
        </h4>
        <span style={{ fontSize: "0.9em", color: "#6c757d" }}>
          {isOpen ? "Haz clic para ocultar" : "Haz clic para ver detalles"}
        </span>
      </div>

      {isOpen && (
        <>
          {availableYears.map((year) => (
            <div key={year} style={{ marginBottom: "30px" }}>
              <h5
                style={{
                  marginTop: "20px",
                  marginBottom: "10px",
                  color: "#495057",
                }}
              >
                Año {year}
              </h5>
              <Table celled size="small" style={{ fontSize: "0.9em" }}>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell textAlign="center">Mes</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Producción (VPS/VFS)
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Trabajadores
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {months.map((month) => {
                    const production = resultsProductions?.[year]?.[month] || 0;
                    const workers = resultsWorkers?.[year]?.[month] || 0;

                    return (
                      <Table.Row key={month}>
                        <Table.Cell textAlign="center">
                          {t ? t(month) : month}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {production > 0 ? production.toFixed(2) : "-"}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {workers > 0 ? workers : "-"}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
                  <Table.Row
                    style={{ fontWeight: "bold", backgroundColor: "#e9ecef" }}
                  >
                    <Table.Cell textAlign="center">Total</Table.Cell>
                    <Table.Cell textAlign="center">
                      {Object.values(resultsProductions?.[year] || {})
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2)}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {Object.values(resultsWorkers?.[year] || {}).reduce(
                        (a, b) => a + b,
                        0,
                      )}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row
                    style={{
                      fontWeight: "bold",
                      backgroundColor: "#d1ecf1",
                      color: "#0c5460",
                    }}
                  >
                    <Table.Cell textAlign="center">Promedio</Table.Cell>
                    <Table.Cell textAlign="center">
                      {(() => {
                        const values = Object.values(
                          resultsProductions?.[year] || {},
                        );
                        const count = values.filter((v) => v > 0).length;
                        const avg =
                          count > 0
                            ? values.reduce((a, b) => a + b, 0) / count
                            : 0;
                        return avg.toFixed(2);
                      })()}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {(() => {
                        const values = Object.values(
                          resultsWorkers?.[year] || {},
                        );
                        const count = values.filter((v) => v > 0).length;
                        const avg =
                          count > 0
                            ? values.reduce((a, b) => a + b, 0) / count
                            : 0;
                        return avg.toFixed(0);
                      })()}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </div>
          ))}

          <div
            style={{
              fontSize: "0.85em",
              color: "#6c757d",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            <strong>Nota:</strong> Estos valores se utilizan como denominadores
            en los cálculos de intensidad. Producción (VPS/VFS) para intensidad
            industrial y Trabajadores para intensidad doméstica.
          </div>
        </>
      )}
    </div>
  );
}
